/* eslint-disable react/jsx-no-target-blank */
import {AsideMenuItemWithSubMain} from './AsideMenuItemWithSubMain'
import {AsideMenuItem} from './AsideMenuItem'
import {useAuth} from '../../../../app/modules/auth'
import {shouldDisplayFonctionnalite, shouldDisplayModule} from '../../../../components/helpers'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {useMetronicAsideHover} from '../../../../components/useMetronicAsideHover'

export function AsideMenuMain() {
  const {currentUser} = useAuth()
  const onHover = useMetronicAsideHover()

  return (
    <div className={'bg-white rounded-1 py-2'}>
      <AsideMenuItem
        to='/dashboard'
        title='Accueil'
        fontIcon='bi-house'
        icon={'_Accueil.png'}
        bsTitle='Accueil'
        iconDynamicColor={'bg-greenBlue'}
      />

      {(shouldDisplayFonctionnalite(currentUser, 'VOIR CENTRE') ||
        shouldDisplayFonctionnalite(currentUser, 'VOIR GENRE') ||
        shouldDisplayFonctionnalite(currentUser, 'VOIR ROLE') ||
        shouldDisplayFonctionnalite(currentUser, 'VOIR MAIL CLIENT') ||
        shouldDisplayFonctionnalite(currentUser, 'VOIR REMISE GROUPE') ||
        shouldDisplayFonctionnalite(currentUser, 'VOIR MOTIF REFUS') ||
        shouldDisplayFonctionnalite(currentUser, 'VOIR REF TYPE PIECE') ||
        shouldDisplayFonctionnalite(currentUser, 'VOIR EQUIPE') ||
        shouldDisplayFonctionnalite(currentUser, 'VOIR ARTICLE') ||
        shouldDisplayFonctionnalite(currentUser, 'VOIR FOURNISSEUR POT') ||
        shouldDisplayFonctionnalite(currentUser, 'VOIR SERVICE RATTACHEMENT') ||
        shouldDisplayFonctionnalite(currentUser, 'SAV_PARAMETRER')) && (
        <AsideMenuItemWithSub
          to=''
          title='Paramètres'
          // bsTitle='Paramètres'
          fontIcon='bi-gear'
          icon={'_Parametre.png'}
          iconDynamicColor={'bg-greenBlue'}
        >
          {shouldDisplayModule(currentUser, 'ARTICLE', 'VOIR ARTICLE') && (
            <AsideMenuItem
              to='/articles'
              title='Articles'
              iconDynamicColor={'bg-greenBlue'}
            />
          )}
          {shouldDisplayModule(currentUser, 'CENTRE', 'VOIR CENTRE') && (
            <AsideMenuItem
              to='/centres'
              title='Centres'
              iconDynamicColor={'bg-greenBlue'}
            />
          )}
          {shouldDisplayModule(currentUser, 'MAIL CLIENT', 'VOIR MAIL CLIENT') && (
            <AsideMenuItem
              to='/courriel'
              title='Configuration courriel'
              iconDynamicColor={'bg-greenBlue'}
            />
          )}
          {shouldDisplayModule(currentUser, 'DELAIS TRAITEMENT', 'VOIR DELAIS TRAITEMENT') && (
            <AsideMenuItem
              to='/delais-traitement'
              title='Délais de traitement'
              iconDynamicColor={'bg-greenBlue'}
            />
          )}
          {shouldDisplayModule(currentUser, 'DEPOT', 'VOIR DEPOT') && (
            <AsideMenuItem
              to='/depots'
              title='Dépôts'
              iconDynamicColor={'bg-greenBlue'}
            />
          )}
          {shouldDisplayModule(currentUser, 'EQUIPE', 'VOIR EQUIPE') && (
            <AsideMenuItem
              to='/equipes'
              title='Equipes'
              iconDynamicColor={'bg-greenBlue'}
            />
          )}
          {shouldDisplayModule(currentUser, 'FOURNISSEUR POT', 'VOIR FOURNISSEUR POT') && (
            <AsideMenuItem
              to='/referentiel-fournisseur-pot'
              title='Fournisseurs POT'
              iconDynamicColor={'bg-greenBlue'}
            />
          )}
          {shouldDisplayModule(currentUser, 'GENRE', 'VOIR GENRE') && (
            <AsideMenuItem
              to='/genres'
              title='Genres'
              iconDynamicColor={'bg-greenBlue'}
            />
          )}
          {shouldDisplayModule(currentUser, 'REF TYPE PIECE', 'VOIR REF TYPE PIECE') && (
            <AsideMenuItem
              to='/referentiel-type-piece'
              title='Gestion de type pièce'
              iconDynamicColor={'bg-greenBlue'}
            />
          )}
          {shouldDisplayModule(currentUser, 'GROUPE LIBPR', 'VOIR GROUPE LIBPR') && (
            <AsideMenuItem
              to='/groupe-libpr'
              title='Groupe LIBPR'
              iconDynamicColor={'bg-greenBlue'}
            />
          )}
          {shouldDisplayModule(currentUser, 'MOTIF REFUS', 'VOIR MOTIF REFUS') && (
            <AsideMenuItem
              to='/motif-refus'
              title='Motif refus'
              iconDynamicColor={'bg-greenBlue'}
            />
          )}
          {shouldDisplayModule(currentUser, 'PROVENANCE', 'VOIR PROVENANCE') && (
            <AsideMenuItem
              to='/provenances'
              title='Provenances'
              iconDynamicColor={'bg-greenBlue'}
            />
          )}
          {shouldDisplayModule(currentUser, 'SAV', 'SAV_PARAMETRER') && (
            <AsideMenuItem
              to='/sav/parametres/messages'
              title='Messages SAV'
              iconDynamicColor={'bg-greenBlue'}
            />
          )}
          {shouldDisplayModule(currentUser, 'SAV', 'SAV_PARAMETRER') && (
            <AsideMenuItem
              to='/sav/parametres/referentiels'
              title='Référentiels SAV'
              iconDynamicColor={'bg-greenBlue'}
            />
          )}
          {shouldDisplayModule(currentUser, 'REMISE GROUPE CLIENT', 'VOIR REMISE GROUPE') && (
            <AsideMenuItem
              to='/remise'
              title='Remise groupe client'
              iconDynamicColor={'bg-greenBlue'}
            />
          )}
          {shouldDisplayModule(currentUser, 'RESEAU CLIENT', 'VOIR RESEAU CLIENT') && (
            <AsideMenuItem
              to='/reseau-client'
              title='Réseau client'
              iconDynamicColor={'bg-greenBlue'}
            />
          )}
          {shouldDisplayModule(currentUser, 'ROLE UTILI', 'VOIR ROLE') && (
            <AsideMenuItem
              to='/roles'
              title='Rôles utilisateurs'
              iconDynamicColor={'bg-greenBlue'}
            />
          )}
          {shouldDisplayModule(currentUser, 'SERVICE RATTACHEMENT', 'VOIR SERVICE RATTACHEMENT') && (
            <AsideMenuItem
              to='/service-rattachement'
              title='Service de rattachement'
              iconDynamicColor={'bg-greenBlue'}
            />
          )}
          {shouldDisplayModule(currentUser, 'TYPES ACTIONS', 'VOIR TYPE ACTION') && (
            <AsideMenuItem
              to='/types-actions'
              title='Types actions'
              iconDynamicColor={'bg-greenBlue'}
            />
          )}
        </AsideMenuItemWithSub>
      )}

      {shouldDisplayModule(currentUser, 'VEHIC') && (
        <AsideMenuItem
          to='/vehicules'
          title='Véhicules'
          bsTitle='Véhicules'
          fontIcon='bi-car-front'
          icon={'_Vehicule.png'}
          iconDynamicColor={'bg-blueLight'}
        />
      )}

      {shouldDisplayModule(currentUser, 'DEMONTAGE') && (
        <AsideMenuItemWithSub to='' title='Dépose parc' fontIcon='bi-tools' icon={'_Depaneuse.png'}>
          {shouldDisplayFonctionnalite(currentUser, 'VOIR DEMANDE DEMONTAGE') && (
            <AsideMenuItem to='/demontage' title='Véhicule' iconDynamicColor={'bg-blueLight'} />
          )}
          {shouldDisplayFonctionnalite(currentUser, 'VOIR DEMANDE DEMONTAGE') && (
            <AsideMenuItem
              to='/demande-demontage'
              title='Demandes de démontage'
              iconDynamicColor={'bg-blueLight'}
            />
          )}
          {shouldDisplayFonctionnalite(currentUser, 'VOIR DEMANDE TRANSFERT DEMONTAGE') && (
            <AsideMenuItem
              to='/demande-transfert'
              title='Demandes de transfert'
              iconDynamicColor={'bg-blueLight'}
            />
          )}
        </AsideMenuItemWithSub>
      )}

      {shouldDisplayModule(currentUser, 'CATALOG') && (
        <AsideMenuItemWithSub
          to=''
          title='Catalogues'
          // bsTitle='Catalogues'
          fontIcon='bi-folder'
          icon={'_Catalogue.png'}
        >
          <AsideMenuItem to='/catalogues' title='Catalogues' iconDynamicColor={'bg-orangeLight'} />
          <AsideMenuItem
            to='/recherche-catalogue'
            title='Recherche des catalogues'
            iconDynamicColor={'bg-orangeLight'}
          />
        </AsideMenuItemWithSub>
      )}

      {shouldDisplayModule(currentUser, 'POT') && (
        <AsideMenuItem
          to='/pieces-pots'
          title='Achat Pièce'
          bsTitle='Achat Pièce'
          fontIcon='bi-percent'
          icon={'_Panier.png'}
          iconDynamicColor={'bg-orangeLight'}
        />
      )}

      {shouldDisplayModule(currentUser, 'MODIFICATION PRIX') && (
        <AsideMenuItem
          to='/modif-prix'
          title='Tarification'
          bsTitle='Tarification'
          fontIcon='bi bi-currency-dollar'
          icon={'_Tarification.png'}
          iconDynamicColor={'bg-rose'}
        />
      )}

      {shouldDisplayModule(currentUser, 'DEMANDE') && (
        <AsideMenuItem
          to='/demandes'
          title='Demandes client'
          bsTitle='Demandes client'
          fontIcon='bi-person-vcard'
          icon={'_Demandes.png'}
          iconDynamicColor={'bg-rose'}
        />
      )}

      {shouldDisplayModule(currentUser, 'SAV', 'SAV_CONSULTER') && (
        <AsideMenuItem
          to='/sav/liste'
          title='SAV'
          bsTitle='SAV'
          fontIcon='bi-arrow-repeat'
          icon={'_Sav.svg'}
          iconDynamicColor={'bg-cyanLight'}
        />
      )}

      {shouldDisplayModule(currentUser, 'MES ACTIONS') && shouldDisplayFonctionnalite(currentUser, 'VOIR ACTION') && (
        <AsideMenuItem
          to='/mes-actions'
          title='Mes actions'
          bsTitle='Mes actions'
          fontIcon='bi bi-list-task'
          icon={'_Actions.png'}
          iconDynamicColor={'bg-rose'}
        />
      )}

      {shouldDisplayModule(currentUser, 'VENTE') && (
        <AsideMenuItem
          to='/vente'
          title='Client'
          bsTitle='Client'
          fontIcon='bi-people'
          icon={'_Client.png'}
          iconDynamicColor={'bg-violetLight'}
        />
      )}

      {shouldDisplayModule(currentUser, 'UTILI') && (
        <AsideMenuItem
          to='/utilisateurs'
          title='Utilisateurs'
          bsTitle='Utilisateurs'
          fontIcon='bi-person-lines-fill'
          icon={'_Utilisateur.png'}
          iconDynamicColor={'bg-violetLight'}
        />
      )}
    </div>
  )
}
